import { render, staticRenderFns } from "./EditCommitteeModal.vue?vue&type=template&id=27354716"
import script from "./EditCommitteeModal.vue?vue&type=script&lang=ts"
export * from "./EditCommitteeModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports